import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config";

const StripeOnboardingComplete = () => {
  const navigate = useNavigate();

useEffect(() => {
  const confirmStripe = async () => {
    try {
      await axios.get(
        `${API_BASE_URL}/api/stripe/status`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

    } catch (err) {
      console.error("Stripe confirm failed", err);
    }

    setTimeout(() => {
      navigate("/dashboard");
    }, 2500);
  };

  confirmStripe();
}, [navigate]);

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2 style={{ color: "#1b5e20" }}>Stripe Setup Complete 🎉</h2>
      <p>Your payout account is now fully activated.</p>
      <p>You will be redirected to your dashboard...</p>

      <button
        onClick={() => navigate("/dashboard")}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#2e7d32",
          color: "white",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        Go to Dashboard Now
      </button>
    </div>
  );
};

export default StripeOnboardingComplete;
